import { Link } from 'react-router-dom'
import {
  activityEntityHref,
  activityEntityLabel,
  activityListName,
  splitSummaryAroundEntity,
  watchlistAddSummarySuffix,
} from '../../utils/activityEntityLink'

interface AdminActivitySummaryProps {
  summary: string
  meta: Record<string, unknown> | null
}

/**
 * Renders activity summary text with a profile link on the entity name when known.
 */
const AdminActivitySummary: React.FC<AdminActivitySummaryProps> = ({ summary, meta }) => {
  const href = activityEntityHref(meta)
  const entityName = activityEntityLabel(meta)
  const listName = activityListName(meta)
  const parts =
    href && entityName ? splitSummaryAroundEntity(summary, entityName) : null

  if (!parts) {
    return <>{summary}</>
  }

  const watchlistSuffix = listName ? watchlistAddSummarySuffix(listName) : null
  const isWatchlistAdd =
    watchlistSuffix !== null && parts.after === watchlistSuffix

  return (
    <>
      {parts.before}
      <Link to={href} className="text-signal hover:text-signal-700 hover:underline">
        {entityName}
      </Link>
      {isWatchlistAdd ? (
        <>
          {' til watchlist '}
          <em>{listName}</em>
        </>
      ) : (
        parts.after
      )}
    </>
  )
}

export default AdminActivitySummary
